import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { skip } from 'rxjs';

const routes: Routes = [{
  path: '',
  component: HomeComponent,
  data: {
    title: 'MahaSarathi',
    breadcrumb: 'Home',
    description: 'MahaSarathi'
  },
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'landing' },
    { path: 'landing', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule) },
    { path: 'about-mh-ucdh', loadChildren: () => import('./about-mh-ucdh/about-mh-ucdh.module').then(m => m.AboutMHUCDHModule) },
    { path: 'schemes', loadChildren: () => import('./schemes/schemes.module').then(m => m.SchemesModule) },
    { path: 'schemes/scheme-details',component: HomeComponent, loadChildren: () => import('./scheme-details/scheme-details.module').then(m => m.SchemeDetailsModule) },
    { path: 'gallery', loadChildren: () => import('./gallery/gallery.module').then(m => m.GalleryModule) },
    { path: 'user-manual', loadChildren: () => import('./user-manual/user-manual.module').then(m => m.UserManualModule) },
    { path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule) },
    { path: 'contact-us', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule) },
    { path: 'sitemap', loadChildren: () => import('./sitemap/sitemap.module').then(m => m.SitemapModule) },
    { path: 'disclaimer-and-policies', loadChildren: () => import('./disclaimer-policies/disclaimer-policies.module').then(m => m.DisclaimerPoliciesModule) },
    { path: 'terms-and-conditions', loadChildren: () => import('./terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule) },
    { path: 'faqs', loadChildren: () => import('./faqs/faqs.module').then(m => m.FaqsModule) },
    { path: 'privacy-policy', loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
    { path: 'privacy-policy-mobile', loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
    { path: 'citizen-register', loadChildren: () => import('./citizen-register/citizen-register.module').then(m => m.CitizenRegisterModule) },
    { path: 'circulars', loadChildren: () => import('./circulars/circulars.module').then(m => m.CircularsModule) },

    { path: 'data-access-consent', loadChildren: () => import('./data-access-consent/data-access-consent.module').then(m => m.DataAccessConsentModule) }

  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
